import React, { useEffect, useState } from 'react'
import classNames from 'classnames'
import { Alert, Col, Container, Form, Row } from 'react-bootstrap'

import { Button } from '../../../../../components/Button/Button'
import { useZoomPhoneSettings } from './hooks'

export const ZoomPhone: React.FC = () => {
  const { captureEnabled, hasPhoneCapability, isFetching, isUpdating, save } = useZoomPhoneSettings()

  const [enabled, setEnabled] = useState(captureEnabled)

  useEffect(() => {
    setEnabled(captureEnabled)
  }, [captureEnabled])

  const isDirty = enabled !== captureEnabled

  const onSave = () => save(enabled)

  if (isFetching) {
    return (
      <Container>
        <div className='skeleton mb-2' style={{ width: '100%', height: '70px' }} />
        <div className='skeleton mb-3' style={{ width: '100%', height: '40px' }} />
      </Container>
    )
  }

  const needsReconnect = !hasPhoneCapability
  const disabledText = classNames({ 'text-muted': needsReconnect })

  return (
    <Container className='p-0'>
      {needsReconnect ? (
        <Alert variant='yellow' className='d-flex align-items-center gap-2 text-dark'>
          <i className='bi bi-exclamation-circle-fill' />
          <span>Reconnect Zoom to turn on Zoom Phone.</span>
        </Alert>
      ) : null}

      <Row className='mb-4'>
        <Col>
          <h3 className={disabledText}>Zoom Phone</h3>
          <p className='text-muted'>Manage how Zocks captures your Zoom Phone calls.</p>
          <p className={disabledText}>
            Zocks can capture your Zoom Phone calls when <b>call recording is turned on in your Zoom account</b>. When this is enabled, Zocks processes Zoom
            Phone side recordings to generate the transcript automatically.
          </p>
        </Col>
      </Row>

      <Form onSubmit={(e) => e.preventDefault()}>
        <Container className='d-flex flex-column gap-4 p-0'>
          <Row>
            <Col>
              <Form.Group controlId='captureZoomPhoneCalls'>
                <Form.Check
                  checked={enabled}
                  onChange={(e) => setEnabled(e.target.checked)}
                  type='switch'
                  id='captureZoomPhoneCalls'
                  label='Capture my Zoom Phone calls'
                  disabled={isUpdating || needsReconnect}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row className='mt-2'>
            <Col>
              <Button variant='primary' loading={isUpdating} disabled={!isDirty || needsReconnect} onClick={onSave}>
                Save changes
              </Button>
            </Col>
          </Row>
        </Container>
      </Form>
    </Container>
  )
}
